import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useForm } from '../../../../lib/components';
import { useStore } from '../../../../hooks/useStore';
import { TaxDataView } from './view';
import { TaxDataForm } from './form';
import * as Yup from 'yup';
import { ProfileViewEditBox } from '../shared/profileViewEditBox';

export const EmployeeProfilTaxData = observer(() => {
  const { employeeStore } = useStore();
  const { employeeId } = useParams();
  const { t } = useTranslation();
  const form = useForm();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);

  const renderView = observer(() => <TaxDataView data={employeeStore.currentEmployee?.tax_data} />);

  const renderEdit = () => {
    return (
      <TaxDataForm
        initialValues={{
          children_count: employeeStore.currentEmployee?.tax_data?.children_count,
          kinderfreibetrag: employeeStore.currentEmployee?.tax_data?.kinderfreibetrag,
          steuerklasse: employeeStore.currentEmployee?.tax_data?.steuerklasse || '',
          religion: employeeStore.currentEmployee?.tax_data?.religion || false,
          missing_fields: employeeStore.currentEmployee?.tax_data?.missing_fields
        }}
        validationSchema={{
          children_count: Yup.number()
            .typeError(t('form:INVALID_NUMBER'))
            .min(0, t('form:MUST_BE_GREATER_THAN', { min: 0 })),
          kinderfreibetrag: Yup.number()
            .typeError(t('form:INVALID_NUMBER'))
            .min(0, t('form:MUST_BE_GREATER_THAN', { min: 0 })),
          steuerklasse: Yup.number().required(t('form:FIELD_IS_REQUIRED'))
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            if (employeeId) {
              await employeeStore.updateEmployeeTaxData(employeeId, values);
            }
          } catch (error) {
            console.error(error);
          }
        }}
      />
    );
  };

  return (
    <ProfileViewEditBox
      title={t('company:TAX_DATA')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
